import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { QUERY_KEYS } from 'src/enums';
import { EditProfilePayload } from 'src/models/service';
import { editProfileInfo } from 'src/services/api';

const useUpdateProfile = () => {
  const client = useQueryClient();
  const { mutate, isLoading } = useMutation<void, AxiosError, EditProfilePayload>(
    ['edit-profile'],
    (payload) => editProfileInfo(payload),
    {
      onSettled: () => {
        client.invalidateQueries([QUERY_KEYS.PROFILE]);
      }
    }
  );

  return {
    mutate,
    isLoading
  };
};

export default useUpdateProfile;
